module.exports = __webpack_public_path__ + "img/GAME_CARDRIVE1.87465b24.jpg";